import styled from 'styled-components'

export const DeliveryContainer = styled.div`
  background-color: white;
  position: relative;
  width: 33.33%;
  height: 100vh;
  overflow-y: auto;
  @media (max-width: 990px) {
    width: 100%;
    height: inherit;
  }
`

export const DeliverWraper = styled.div`
  padding: 0px 15px;
  margin-bottom: 20px;
`


